import pdfMake from 'pdfmake/build/pdfmake';
import * as pdfFonts from 'pdfmake/build/vfs_fonts';

// pdfMake fontlarını kaydet
if (pdfFonts && pdfFonts.pdfMake && pdfFonts.pdfMake.vfs) {
    pdfMake.vfs = pdfFonts.pdfMake.vfs;
} else if (pdfFonts) {
    pdfMake.vfs = pdfFonts;
}

/**
 * Onarım Açılış Formu PDF (pdfMake ile)
 * Türkçe karakter desteği tam olarak çalışır
 */
class RepairOpeningPdfFormPdfMake {
    /**
     * PDF'i oluşturur
     * @param {Object} data - PDF için gerekli veriler
     * @param {Object} translations - Dil çevirileri
     * @returns {Object} - pdfMake PDF dökümanı
     */
    generate(data, translations = {}) {
        const today = new Date().toLocaleDateString('tr-TR');
        const trafficDate = data.dateOfTraffic ? new Date(data.dateOfTraffic).toLocaleDateString('tr-TR') : '-';
        const acceptDate = data.vehicleAcceptDate ? new Date(data.vehicleAcceptDate).toLocaleDateString('tr-TR') : '-';

        let statusText = '-';
        if (data.status === 5) {
            statusText = translations.statusOpen;
        } else if (data.status === 10) {
            statusText = translations.statusClose;
        }


        const docDefinition = {
            pageSize: 'A4',
            pageMargins: [40, 40, 40, 40],
            content: [
                // Başlık - Logo ve Form Başlığı
                {
                    columns: [
                        {
                            // Sol: KARSAN Logo
                            width: 'auto',
                            columns: [
                                {
                                    width: 35,
                                    canvas: [
                                        // Sol Üst Üçgen
                                        {
                                            type: 'polyline',
                                            points: [
                                                { x: 0, y: 0 },
                                                { x: 18, y: 0 },
                                                { x: 1, y: 18 }
                                            ],
                                            color: '#F05133',
                                            closePath: true
                                        },
                                        // Sol Alt Üçgen
                                        {
                                            type: 'polyline',
                                            points: [
                                                { x: 0, y: 36 },
                                                { x: 18, y: 36 },
                                                { x: 1, y: 18 }
                                            ],
                                            color: '#F05133',
                                            closePath: true
                                        },
                                        // Sol Dikey Çizgi
                                        {
                                            type: 'rect',
                                            x: 0, y: 0,
                                            w: 1, h: 36,
                                            color: '#F05133'
                                        },
                                        // Sağ Üçgen
                                        {
                                            type: 'polyline',
                                            points: [
                                                { x: 36, y: 0 },
                                                { x: 36, y: 36 },
                                                { x: 18, y: 18 }
                                            ],
                                            color: '#F05133',
                                            closePath: true
                                        }
                                    ]
                                },
                                {
                                    text: 'KARSAN',
                                    fontSize: 14,
                                    bold: true,
                                    color: '#76777A',
                                    margin: [5, 8, 0, 0]
                                }
                            ]
                        },
                        {
                            // Sağ: Form Başlığı
                            text: translations.title || 'Onarım Açılış Formu',
                            fontSize: 16,
                            bold: true,
                            color: '#273A81',
                            alignment: 'right',
                            width: '*',
                            margin: [0, 5, 0, 0]
                        }
                    ],
                    margin: [0, 0, 0, 20]
                },

                // Satır 1: Döküman No, Tarih, Ünvan
                {
                    columns: [
                        this.createField(translations.documentNo || 'Döküman No', data.id || '-'),
                        this.createField(translations.date || 'Tarih', today),
                        this.createField(translations.title2 || 'Ünvan', '-')
                    ],
                    margin: [0, 0, 0, 0]
                },

                // Satır 2: Araç Sahibi, Telefon
                {
                    columns: [
                        { width: '65%', ...this.createField(translations.vehicleOwner || 'Araç Sahibi', data.customerNameSurname || '-') },
                        { width: '35%', ...this.createField(translations.phone || 'Telefon', data.customerPhone || '-') }
                    ],
                    columnGap: 5,
                    margin: [0, 0, 0, 0]
                },

                // Satır 3: Plaka, Şasi No
                {
                    columns: [
                        { width: '32%', ...this.createField(translations.licensePlate || 'Plaka', data.licensePlate || '-') },
                        { width: '68%', ...this.createField(translations.chassisNo || 'Şasi No', data.chassisNo || '-') },
                    ],
                    columnGap: 5,
                    margin: [0, 0, 0, 0]
                },

                // Satır 4: Marka, Model, Motor No
                {
                    columns: [
                        this.createField(translations.brand || 'Marka', data.brand || '-'),
                        this.createField(translations.model || 'Model', data.model || '-'),
                        this.createField(translations.status || 'Durum', statusText)

                    ],
                    margin: [0, 0, 0, 0]
                },

                // Satır 5: KM, Trafiğe Çıkış Tarihi, Araç Kabul Tarihi
                {
                    columns: [
                        this.createField(translations.km || 'KM', data.kmInformation || '-'),
                        this.createField(translations.trafficDate || 'Trafiğe Çıkış Tarihi', trafficDate),
                        this.createField(translations.vehicleAcceptDate || 'Araç Kabul Tarihi', acceptDate)
                    ],
                    margin: [0, 0, 0, 0]
                },

                // Satır 6: Teslim Alan, Teslim Eden
                {
                    columns: [
                        this.createField(translations.receivedBy || 'Teslim Alan', data.receivingPerson || '-'),
                        this.createField(translations.deliveredBy || 'Teslim Eden', data.receivingDeliveryPerson || '-'),
                    ],
                    margin: [0, 0, 0, 0]
                },

                // Beyan Açıklaması
                {
                    table: {
                        widths: ['*'],
                        body: [
                            [
                                {
                                    stack: [
                                        { text: translations.customerStatement || 'Müşteri Beyanı', fontSize: 10, bold: true, margin: [0, 0, 0, 5] },
                                        { 
                                            text: this.wrapLongWords(data.customerStatement || '-', 80), 
                                            fontSize: 9,
                                            lineHeight: 1.3
                                        }
                                    ],
                                    margin: [5, 5, 5, 15]
                                }
                            ]
                        ]
                    },
                    layout: {
                        hLineWidth: () => 1,
                        vLineWidth: () => 1,
                        hLineColor: () => '#CCCCCC',
                        vLineColor: () => '#CCCCCC',
                        paddingLeft: () => 5,
                        paddingRight: () => 5,
                        paddingTop: () => 5,
                        paddingBottom: () => 5
                    },
                    margin: [0, 0, 0, 0]
                },

                // İmza Alanları
                {
                    columns: [
                        {
                            table: {
                                widths: ['*'],
                                body: [
                                    [{ text: translations.signature || 'Araç Teslim Eden İmzası', fontSize: 10, bold: true, margin: [5, 40, 5, 5] }]
                                ]
                            },
                            layout: {
                                hLineWidth: () => 1,
                                vLineWidth: () => 1,
                                hLineColor: () => '#CCCCCC',
                                vLineColor: () => '#CCCCCC'
                            },
                            width: '48%'
                        },
                        { width: '4%', text: '' },
                        {
                            table: {
                                widths: ['*'],
                                body: [
                                    [{ text: translations.authorizedSignature || 'Araç Teslim Alan İmzası', fontSize: 10, bold: true, margin: [5, 40, 5, 5] }]
                                ]
                            },
                            layout: {
                                hLineWidth: () => 1,
                                vLineWidth: () => 1,
                                hLineColor: () => '#CCCCCC',
                                vLineColor: () => '#CCCCCC'
                            },
                            width: '48%'
                        }
                    ],
                    margin: [0, 0, 0, 10]
                },

                // Rapor Tarihi
                {
                    text: `${translations.reportDate || 'Rapor Tarihi'}: ${today}`,
                    fontSize: 9,
                    alignment: 'right',
                    margin: [0, 5, 0, 0]
                }
            ],
            defaultStyle: {
                font: 'Roboto'
            }
        };

        return pdfMake.createPdf(docDefinition);
    }

    /**
     * Uzun kelimeleri böler (word wrap için)
     */
    wrapLongWords(text, maxLength = 80) {
        if (!text) return '-';
        
        // Boşluklarla ayrılmış kelimeleri al
        const words = text.split(' ');
        const wrappedWords = [];
        
        words.forEach(word => {
            if (word.length > maxLength) {
                // Uzun kelimeyi böl
                for (let i = 0; i < word.length; i += maxLength) {
                    wrappedWords.push(word.substring(i, i + maxLength));
                }
            } else {
                wrappedWords.push(word);
            }
        });
        
        return wrappedWords.join(' ');
    }

    /**
     * Alan kutusu oluşturur
     */
    createField(label, value) {
        return {
            table: {
                widths: ['*'],
                body: [
                    [
                        {
                            stack: [
                                { text: label, fontSize: 8, color: '#666666', margin: [0, 0, 0, 2] },
                                { text: value || '-', fontSize: 10, bold: true, color: '#000000' }
                            ],
                            margin: [5, 3, 5, 3]
                        }
                    ]
                ]
            },
            layout: {
                hLineWidth: () => 1,
                vLineWidth: () => 1,
                hLineColor: () => '#CCCCCC',
                vLineColor: () => '#CCCCCC'
            }
        };
    }

    /**
     * PDF'i görüntüler
     */
    viewPdf(pdfDoc) {
        pdfDoc.open();
    }

    /**
     * PDF'i indirir
     */
    downloadPdf(pdfDoc, filename = 'onarim-acilis-formu.pdf') {
        pdfDoc.download(filename);
    }
}

export default RepairOpeningPdfFormPdfMake;
